import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

// Components
import Loader from "../../components/common/Loader";
import Menu from "../../components/home1/Menu";
import Navbar from "../../components/home1/Navbar";

import Map from "../../components/innerpage/contact/Map";
import Footer2 from "../../components/home2/Footer";
import ContactForm from "../../components/innerpage/contact/ContactForm";
import ContactOffices from "../../components/innerpage/contact/ContactOffices";

function Contact() {
  const { t } = useTranslation('contact');
  const { t: tCommon } = useTranslation();
  const [showMap, setShowMap] = useState(false);

  return (
    <>
      <Helmet>
        {/* CSS Styles */}
        <link
          rel="stylesheet"
          href="/home1/assets/css/home_1_style.css"
        />
        <link
          rel="stylesheet"
          href="/home5_residence/assets/css/home_5_style.css"
        />
        <link
          rel="stylesheet"
          href="/home2/assets/css/home_2_style.css"
        />
        <link rel="stylesheet" href="/innerpages/assets/css/inerpages.css" />

        {/* JS Scripts */}
        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
       
        <script src="/innerpages/assets/js/innerpages.js" defer></script>

        {/* Meta Tags */}
      </Helmet>

      <div className="home-style1 inner-page-header-active">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <div style={{ position: 'relative', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
              <img src="/home1/assets/img/projects/proj7.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)' }}></div>
            </div>
            <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', color: 'white', padding: '60px 20px' }}>
              <nav aria-label="breadcrumb" style={{ marginBottom: '20px' }}>
                <ol style={{ display: 'flex', justifyContent: 'center', listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginRight: '8px' }}>
                    <a href="/" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none' }}>{tCommon('projectPage.breadcrumb.home')}</a>
                  </li>
                  <li style={{ marginRight: '8px', color: 'rgba(255,255,255,0.7)' }}>/</li>
                  <li style={{ color: 'white' }}>{t('title')}</li>
                </ol>
              </nav>
              <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '20px', fontFamily: 'Montserrat, sans-serif' }}>
                {t('title')}
              </h1>
              <p style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
                {t('description')}
              </p>
            </div>
          </div>
          <main>
            <ContactOffices />
            
            {/* Combined Contact Form and Map Section */}
            <section style={{ backgroundColor: '#ffffff', padding: '100px 0' }}>
              <div className="container" style={{ maxWidth: '900px' }}>
                <ContactForm />

                <div style={{ marginTop: '40px', textAlign: 'center' }}>
                  <button
                    type="button"
                    onClick={() => setShowMap(!showMap)}
                    style={{
                      backgroundColor: 'transparent',
                      color: 'rgb(73, 69, 56)',
                      border: '1.5px solid rgb(73, 69, 56)',
                      padding: '12px 32px',
                      borderRadius: '8px',
                      fontSize: '0.95rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {t('form.viewMapButton')}
                  </button>
                </div>

                {showMap && (
                  <div style={{ marginTop: '40px', minHeight: '450px' }}>
                    <p style={{
                      textAlign: 'center',
                      color: '#6b7280',
                      marginBottom: '20px',
                      fontSize: '1rem'
                    }}>
                      {t('info.address.value')}
                    </p>
                    <Map />
                  </div>
                )}
              </div>

              <style>{`
                @media (max-width: 991px) {
                  section {
                    padding: 80px 0 !important;
                  }
                }

                @media (max-width: 767px) {
                  section {
                    padding: 60px 0 !important;
                  }
                }
              `}</style>
            </section>
          </main>
          <Footer2 />
        </div>
      </div>
    </>
  );
}

export default Contact;
